
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import { getintegral } from '@/api/user.js'
import { getClassify, getProductList } from '@/api/youzheng.js'
import { getaddlog } from '@/api/hgfw'
import iconOrder from '@/assets/mall/mall-01.png'
import banner from '@/assets/mall/mall-02.png'
import config from '@/config'
import Scroll from '@/components/scroller'
export default {
name: 'mallIndex',
components: {
Flexbox,
FlexboxItem,
Tab,
TabItem,
Scroll
},
data () {
return {
iconOrder: iconOrder,
banner: banner,
owner_type: config.owner_type,
select: 0,
getBarWidth: function (index) {
if (index === 0) {
return 30 + 'px'
} else {
return 60 + 'px'
}
},
vipname: this.$store.state.user.personObj.acctname,
integral: 0,
classifyList: [{
producttype: '',
producttypename: '全部'
}],
goodsList: [],
page: 1,
rows: 10,
baseUrl: config.baseUrl + '/',
producttype: '',
isshow: false,
notFirstLoad: false,
loadMoreDom: null
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
watch: {
producttype (newVal, oldVal) {
this.refresh()
}
},
methods: {
getAdd () {
getaddlog({
accountid: this.accountid,
moduleid: 1200,
submoduleid: 120103
}).then(res => {
})
},
ontab (index, producttype) {
this.select = index
this.producttype = producttype
},
getintegralTotal () {
/* 得到用户积分总信息 */
getintegral({
accountid: this.accountid,
owner_type: this.owner_type,
userid: this.userid
}).then(res => {
this.integral = res.returnValue
})
},
gettype () {
getClassify().then(res => {
if (res.returnValue !== '' && res.returnValue.length > 0) {
res.returnValue.forEach((item, index) => {
this.classifyList.push({
producttype: item.producttype,
producttypename: item.producttypename
})
})
}
})
},
getlist (type, done) {
getProductList({
prodname: '',
usercredit: 0,
ordertype: 0,
grouptype: 0,
producttype: this.producttype,
isnew: 0,
page: this.page,
rows: this.rows,
orderdesc: ''
}).then(res => {
this.notFirstLoad = true
if (type === 'refresh' || type === 'search') {
this.goodsList = []
this.listDom.scrollTop = 0
}
if (res.returnValue.list !== '' && res.returnValue.list.length > 0) {
res.returnValue.list.forEach(item => {
this.goodsList.push({
ID: item.ID,
PRODNAME: item.PRODNAME,
TITLEIMG: item.TITLEIMG,
CREDIT: item.CREDIT,
STARTDATE: item.STARTDATE,
AMOUNT: item.AMOUNT,
EXCHAGE: item.EXCHAGE,
GROUPTYPE: item.GROUPTYPE,
TIMELIMIT: item.TIMELIMIT,
PRICE: item.PRICE
})
})
}
if (res.returnValue.list.length === 0 || res.returnValue.count < this.rows) {
if (res.returnValue.count === 0) {
this.isshow = true
} else {
this.isshow = false
this.loadMoreDom.innerHTML = '<span style="display: none;">加载中……</span> <span>我也是有底线的～o～</span>'
setTimeout(() => {
this.loadMoreDom.style.display = 'none'
}, 2000)
}
}
done && done()
}).catch(() => {
this.notFirstLoad = true
done && done()
})
},

refresh (done) {
this.page = 1
this.loadMoreDom.innerText = '加载中...'
this.getlist('refresh', done)
},

loadMore (done) {
this.page++
this.loadMoreDom.innerHTML = '<span>加载中……</span><span style="display: none;">我也是有底线的～o～</span>'
this.getlist('more', done)
},
goMore (id) {
this.$router.push({ name: 'mallProductDetail', params: { id: id } })
},
lianxisj () {
this.$vux.alert.show({
content: '商家电话号码：0577-86162738'
})
}
},
activated () {
this.listDom.scrollTop = config.scrollPosition.y
},
beforeRouteLeave (to, from, next) {
config.scrollPosition.y = this.listDom.scrollTop
next()
},
mounted () {
this.loadMoreDom = this.$el.querySelector('.load-more')
this.listDom = this.$el.querySelector('.list-scroll')
},
created () {
this.getAdd()
this.getintegralTotal()
this.gettype()
this.getlist()
}
}
